import type { ReactElement } from 'react'
import { Icon } from '../icon'

export interface BankDetails {
  name: string
  enNames: string[]
  icon: ReactElement
  cardNo: string
  code: string
}

export const bankDetailsList: BankDetails[] = [
  {
    name: 'شهر',
    enNames: ['Shahr', 'CIY'],
    icon: <Icon title='شهر' size='sm' name='Shahr' />,
    cardNo: '502806',
    code: 'CIYBIR',
  },
  {
    name: 'شهر',
    enNames: ['Shahr', 'CIY'],
    icon: <Icon title='شهر' size='sm' name='Shahr' />,
    cardNo: '504706',
    code: 'CIYBIR',
  },
  {
    name: 'ملی ایران',
    enNames: ['Melli', 'MELL'],
    icon: <Icon size='sm' name='Melli' />,
    cardNo: '603799',
    code: 'MELIIR',
  },
  {
    name: 'ملی ایران',
    enNames: ['Melli', 'MELL'],
    icon: <Icon size='sm' name='Melli' />,
    cardNo: '170019',
    code: 'MELIIR',
  },
  {
    name: 'اقتصاد نوین',
    enNames: ['EghtesatNovin', 'EGN'],
    icon: <Icon size='sm' name='EghtesatNovin' />,
    cardNo: '627412',
    code: 'BEGNIR',
  },
  {
    name: 'ملت',
    enNames: ['Mellat', 'BKMT'],
    icon: <Icon size='sm' name='Mellat' />,
    cardNo: '610433',
    code: 'BKMTIR',
  },
  {
    name: 'ملت',
    enNames: ['Mellat', 'BKMT'],
    icon: <Icon size='sm' name='Mellat' />,
    cardNo: '991975',
    code: 'BKMTIR',
  },
  {
    name: 'رفاه',
    enNames: ['Refah', 'REF'],
    icon: <Icon size='sm' name='Refah' />,
    cardNo: '589463',
    code: 'REFAIR',
  },
  {
    name: 'توسعه تعاون',
    enNames: ['ToseeTaavon', 'TTB'],
    icon: <Icon size='sm' name='ToseeTaavon' />,
    cardNo: '502908',
    code: 'TTBIIR',
  },
  {
    name: 'توسعه صادرات',
    enNames: ['Saderat', 'EDB'],
    icon: <Icon size='sm' name='Saderat' />,
    cardNo: '627648',
    code: 'EDBIIR',
  },
  {
    name: 'توسعه صادرات',
    enNames: ['Saderat', 'EDB'],
    icon: <Icon size='sm' name='Saderat' />,
    cardNo: '207177',
    code: 'EDBIIR',
  },
  {
    name: 'تجارت',
    enNames: ['Tejarat', 'BTEJ'],
    icon: <Icon size='sm' name='Tejarat' />,
    cardNo: '627353',
    code: 'BTEJIR',
  },
  {
    name: 'تجارت',
    enNames: ['Tejarat', 'BTEJ'],
    icon: <Icon size='sm' name='Tejarat' />,
    cardNo: '585983',
    code: 'BTEJIR',
  },
  {
    name: 'سینا',
    enNames: ['Sina', 'SINA'],
    icon: <Icon size='sm' name='Sina' />,
    cardNo: '639346',
    code: 'SINAIR',
  },
  {
    name: 'مسکن',
    enNames: ['Maskan', 'BKMN'],
    icon: <Icon size='sm' name='Maskan' />,
    cardNo: '628023',
    code: 'BKMNIR',
  },
  {
    name: 'پست ایران',
    enNames: ['Postbank', 'PBI'],
    icon: <Icon size='sm' name='Postbank' />,
    cardNo: '627760',
    code: 'PBIRIR',
  },
  {
    name: 'صنعت و معدن',
    enNames: ['Sanatvamadan', 'BOIM'],
    icon: <Icon size='sm' name='Sanatvamadan' />,
    cardNo: '627961',
    code: 'BOIMIR',
  },
  {
    name: 'پارسیان',
    enNames: ['Parsian', 'BKPA', 'PAR'],
    icon: <Icon size='sm' name='Parsian' />,
    cardNo: '622106',
    code: 'BKPAIR',
  },
  {
    name: 'پاسارگاد',
    enNames: ['Pasargad', 'BKB', 'PAS', 'بانک پاسارگاد'],
    icon: <Icon size='sm' name='Pasargad' />,
    cardNo: '502229',
    code: 'BKBPIR',
  },
  {
    name: 'پاسارگاد',
    enNames: ['Pasargad', 'BKB', 'PAS', 'بانک پاسارگاد'],
    icon: <Icon size='sm' name='Pasargad' />,
    cardNo: '639347',
    code: 'BKBPIR',
  },
  {
    name: 'کارآفرین',
    enNames: ['Karafarin', 'KBID'],
    icon: <Icon size='sm' name='Karafarin' />,
    cardNo: '627488',
    code: 'KBIDIR',
  },
  {
    name: 'سامان',
    enNames: ['Saman', 'SABC', 'SAM'],
    icon: <Icon size='sm' name='Saman' />,
    cardNo: '621986',
    code: 'SABCIR',
  },
  {
    name: 'سرمایه',
    enNames: ['Sarmayeh', 'SRMB'],
    icon: <Icon size='sm' name='Sarmayeh' />,
    cardNo: '639607',
    code: 'SRMBIR',
  },
  {
    name: 'صادرات',
    enNames: ['Saderat', 'EDB'],
    icon: <Icon size='sm' name='Saderat' />,
    cardNo: '603769',
    code: 'BSIRIR',
  },
  {
    name: 'صادرات',
    enNames: ['Saderat', 'BSI'],
    icon: <Icon size='sm' name='Saderat' />,
    cardNo: '903769',
    code: 'BSIRIR',
  },
  {
    name: 'سپه',
    enNames: ['Sepah', 'BSP'],
    icon: <Icon size='sm' name='Sepah' />,
    cardNo: '589210',
    code: 'SEPBIR',
  },
  {
    name: 'سپه',
    enNames: ['Sepah', 'SEP'],
    icon: <Icon size='sm' name='Sepah' />,
    cardNo: '604932',
    code: 'SEPBIR',
  },
  {
    name: 'کشاورزی',
    enNames: ['Keshavarzi', 'KESH'],
    icon: <Icon size='sm' name='Keshavarzi' />,
    cardNo: '603770',
    code: 'KESHIR',
  },
  {
    name: 'انصار',
    enNames: ['Ansar', 'ANS'],
    icon: <Icon size='sm' name='Ansar' />,
    cardNo: '627381',
    code: 'ANSBIR',
  },
  {
    name: 'دی',
    enNames: ['Day'],
    icon: <Icon size='sm' name='Day' />,
    cardNo: '502938',
    code: 'DAYBIR',
  },
  {
    name: 'آینده',
    enNames: ['Ayandeh', 'AYN'],
    icon: <Icon size='sm' name='Ayandeh' />,
    cardNo: '636214',
    code: 'AYBKIR',
  },
  {
    name: 'خاورمیانه',
    enNames: ['Khavarmiane', 'KHM'],
    icon: <Icon size='sm' name='Khavarmiane' />,
    cardNo: '585947',
    code: 'KHMIIR',
  },
  {
    name: 'خاورمیانه',
    enNames: ['Khavarmiane', 'KHM'],
    icon: <Icon size='sm' name='Melli' />,
    cardNo: '505809',
    code: 'KHMIIR',
  },
  {
    name: 'موسسعه مالی اعتباری کوثر',
    enNames: ['Kosar', 'KOSR'],
    icon: <Icon size='sm' name='Kosar' />,
    cardNo: '505801',
    code: 'KOSRIR',
  },
  {
    name: 'مرکزی',
    enNames: ['Markazi', 'BMJI'],
    icon: <Icon size='sm' name='Markazi' />,
    cardNo: '636795',
    code: 'BMJIIR',
  },
  {
    name: 'گردشگری',
    enNames: ['Gardeshgari', 'TOSM'],
    icon: <Icon size='sm' name='Gardeshgari' />,
    cardNo: '505416',
    code: 'TOSMIR',
  },
  {
    name: 'رسالت',
    enNames: ['Resalat', 'RESB'],
    icon: <Icon size='sm' name='Resalat' />,
    cardNo: '504172',
    code: 'RESBIR',
  },
  {
    name: 'حکمت ایرانیان',
    enNames: ['Hekmat', 'HEKM'],
    icon: <Icon size='sm' name='Hekmat' />,
    cardNo: '636949',
    code: 'HEKMIR',
  },
  {
    name: 'موسسه اعتباری توسعه',
    enNames: ['Tosee', 'BTOS'],
    icon: <Icon size='sm' name='Tosee' />,
    cardNo: '628157',
    code: 'BTOSIR',
  },
  {
    name: 'قرض الحسنه مهر ایران',
    enNames: ['Mehr', 'MEHR'],
    icon: <Icon size='sm' name='Mehr' />,
    cardNo: '606373',
    code: 'MEHRIR',
  },
  {
    name: 'ایران زمین',
    enNames: ['Iranzamin', 'IRZA'],
    icon: <Icon size='sm' name='Iranzamin' />,
    cardNo: '505785',
    code: 'IRZAIR',
  },
  {
    name: 'قوامین',
    enNames: ['Ghavamin', 'GHAV'],
    icon: <Icon size='sm' name='Ghavamin' />,
    cardNo: '639599',
    code: 'GHAVIR',
  },
  {
    name: 'موسسه اعتباری ملل',
    enNames: ['Melal'],
    icon: <Icon size='sm' name='Melal' />,
    cardNo: '606256',
    code: 'MELLIR',
  },
  {
    name: 'موسسه اعتباری نور',
    enNames: ['Noor', 'NOOR'],
    icon: <Icon size='sm' name='Melli' />,
    cardNo: '507677',
    code: 'MELLIR',
  },
  {
    name: 'بانک ناشناخته',
    enNames: ['Unknown', 'UNKNOWN'],
    icon: <Icon size='sm' name='Landmark' color='fill-neutral-surface-80' />,
    cardNo: 'Unknown',
    code: 'UNKNOWNIR',
  },
  // {
  //   name: "ایران و ونزوئلا",
  //   icon: <Icon size="sm" name="Noor" />,
  //   cardNo: "581874",
  //   code: "IRZAIR",
  // },
  // TODO: Find an ID for this bank and enter it in the code
  // {
  //   name: "مهر اقتصاد",
  //   icon: MehrEghtesadLogo,
  //   cardNo: "639370",
  //   code: "",
  // },
]
